// js/common/utilities/format-money.js
function formatMoney(cents, format = "") {
  if (typeof cents === "string") {
    cents = cents.replace(".", "");
  }
  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/, formatString = format || window.settings.moneyFormat;
  function defaultTo(value2, defaultValue) {
    return value2 == null || value2 !== value2 ? defaultValue : value2;
  }
  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultTo(precision, 2);
    thousands = defaultTo(thousands, ",");
    decimal = defaultTo(decimal, ".");
    if (isNaN(number) || number == null) {
      return 0;
    }
    number = (number / 100).toFixed(precision);
    let parts = number.split("."), dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands), centsAmount = parts[1] ? decimal + parts[1] : "";
    return dollarsAmount + centsAmount;
  }
  let value = "";
  switch (formatString.match(placeholderRegex)[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;
    case "amount_with_space_separator":
      value = formatWithDelimiters(cents, 2, " ", ".");
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;
    case "amount_with_apostrophe_separator":
      value = formatWithDelimiters(cents, 2, "'", ".");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ".", ",");
      break;
    case "amount_no_decimals_with_space_separator":
      value = formatWithDelimiters(cents, 0, " ");
      break;
    case "amount_no_decimals_with_apostrophe_separator":
      value = formatWithDelimiters(cents, 0, "'");
      break;
    default:
      value = formatWithDelimiters(cents, 2);
      break;
  }
  if (formatString.indexOf("with_comma_separator") !== -1) {
    return formatString.replace(placeholderRegex, value);
  } else {
    return formatString.replace(placeholderRegex, value);
  }
}
var currencyFormat = window.settings.currencyCodeEnabled ? window.settings.moneyWithCurrencyFormat : window.settings.moneyFormat;
class configuratorDrawer extends HTMLElement {
  constructor() {
    super();
    var temp_this = this;
    this.addEventListener(
      'keyup',
      (evt) => evt.code === 'Escape' && this.close()
    );
    this.querySelector('#configuratorDrawer-Overlay').addEventListener(
      'click',
      this.close.bind(this)
    );
    this.setHeaderCartIconAccessibility();

    //remove hide on first load, this is added to prevent showing a white space on top when first load the page
    this.parentElement.classList.remove('hide-on-first-load');

    let flockOptions = temp_this.querySelectorAll('.flock-options input[name="flock-option"]');
    flockOptions.forEach(function (option) {
      option.addEventListener('click', (event) => {
        temp_this.updateFormInput(event.target);
        temp_this.updateJerseyFlock(event);
        temp_this.toggleFlockHandler(event);
      })
    })

    window.addEventListener('click', function (event) {
      if (temp_this.querySelector('.flock-players-options .selected-name-container')
        && !temp_this.querySelector('.flock-players-options .selected-name-container').contains(event.target)) {
        temp_this.togglePlayersDropdown(event, true);
      }
    });
    if (temp_this.querySelector('.selected-name-container'))
      temp_this.querySelector('.selected-name-container').addEventListener('click', temp_this.togglePlayersDropdown.bind(this));

    temp_this.querySelectorAll('.flock-players-options ul li').forEach(function (option) {
      option.addEventListener('click', (event) => {
        temp_this.pickPlayer(event)
      });
    })

    let drawerAction = temp_this.querySelectorAll('.drawer__footer .button');
    drawerAction.forEach(function (button) {
      button.addEventListener('click', (event) => {
        temp_this.configuratorAction(event);
      })
    })
    if (temp_this.querySelector('.personalize-inputs #flock-personalize-name'))
      temp_this.querySelector('.personalize-inputs #flock-personalize-name').addEventListener('keyup', function (event) {
        temp_this.writeNameOnJersey('', event);
        temp_this.updateInputMaxLenText(event);
      })

    if (temp_this.querySelector('.personalize-inputs #flock-personalize-number'))
      temp_this.querySelector('.personalize-inputs #flock-personalize-number').addEventListener('keyup', function (event) {
        temp_this.writeNumberOnJersey('', event, temp_this);
        temp_this.updateInputMaxLenText(event, true);
      })

    let badgesOptions = temp_this.querySelectorAll('.badge-options input[name="badge-option"]');
    badgesOptions.forEach(function (badge) {
      badge.addEventListener('click', function (event) {
        temp_this.addBadgeOnJersey(event);
        temp_this.updateFormInput(event.target);
      })
    })
  }

  updateInputMaxLenText(triggeredEvent, isNumber = false) {
    if (triggeredEvent == null) {
      this.querySelector('.personalize-inputs #flock-personalize-name').nextElementSibling ? this.querySelector('.personalize-inputs #flock-personalize-name').nextElementSibling.innerHTML = '0/13' : '';
      this.querySelector('.personalize-inputs #flock-personalize-number').nextElementSibling ? this.querySelector('.personalize-inputs #flock-personalize-number').innerHTML = '0/2' : '';
    } else {
      let maxLen = isNumber ? 2 : 13;
      triggeredEvent.target.nextElementSibling ? triggeredEvent.target.nextElementSibling.innerHTML = triggeredEvent.target.value.length + '/' + maxLen : '';
    }
  }

  updatePrice() {
    let productFormID = document.querySelector('.product-configurator-block') ? document.querySelector('.product-configurator-block').getAttribute('form-id') : '';
    let productSectionID = document.querySelector('.product-configurator-block') ? document.querySelector('.product-configurator-block').getAttribute('section-id') : '';
    if (productFormID) {
      let badgePrice = document.querySelector('form[id="' + productFormID + '"] input[name="badge-option"]') ? document.querySelector('form[id="' + productFormID + '"] input[name="badge-option"]').getAttribute('variant-price') : 0;
      let flockPrice = document.querySelector('form[id="' + productFormID + '"] input[name="flock-option"]') ? document.querySelector('form[id="' + productFormID + '"] input[name="flock-option"]').getAttribute('variant-price') : 0;
      let currentVariantPriceElem = document.querySelectorAll('#ProductInfo-' + productSectionID + ' .original-price');

      let productID = document.querySelector('.product-configurator-block')?.getAttribute('product-id') ? document.querySelector('.product-configurator-block').getAttribute('product-id') : '';
      let playerName = document.querySelector('form[id="' + productFormID + '"] input[name="flock-option"]') ? document.querySelector('form[id="' + productFormID + '"] input[name="flock-option"]').getAttribute('player-name') : '';
      let badgeID = document.querySelector('.configurator-blocks-container input[name="badge-option"]') ? document.querySelector('.configurator-blocks-container input[name="badge-option"]').getAttribute('product-id') : '';
      let flockID = document.querySelector('.configurator-blocks-container input[name="flock-option"]') ? document.querySelector('.configurator-blocks-container input[name="flock-option"]').getAttribute('product-id') : '';

      currentVariantPriceElem.forEach(function (priceElem) {
        if(priceElem.closest('.product-info-price')){
          let currentVariantPrice = parseInt(priceElem.getAttribute('variant-price')) || 0;

          const scriptDiscount = document.querySelector('script[jersey-discount-json-data]');
          const discounts = scriptDiscount ? JSON.parse(scriptDiscount.textContent) : null;

          let badgePriceInt = parseInt(badgePrice) || 0;
          let flockPriceInt = parseInt(flockPrice) || 0;

          let discountedBadgePrice = badgePriceInt;
          let discountedFlockPrice = flockPriceInt;

          try {
            if (typeof discounts !== 'undefined' && Array.isArray(discounts.discounts) && typeof productID !== 'undefined' && typeof playerName !== 'undefined') {
              const matched = discounts.discounts.filter(function(rule) {
                return String(rule.trigger_product_id) === String(productID) &&
                       String(rule.trigger_attribute_value).toLowerCase() === String(playerName).toLowerCase();
              });
              if (matched.length > 0) {
                let badgeDiscountPct = 0;
                let flockDiscountPct = 0;

                matched.forEach(function(rule) {
                  const pctRaw = parseFloat(rule.discount_percentage);
                  const pct = isNaN(pctRaw) ? 0 : Math.max(0, Math.min(100, pctRaw));

                  if (typeof badgeID !== 'undefined' && String(rule.discount_product_id) === String(badgeID)) {
                    badgeDiscountPct = Math.max(badgeDiscountPct, pct);
                  }
                  if (typeof flockID !== 'undefined' && String(rule.discount_product_id) === String(flockID)) {
                    flockDiscountPct = Math.max(flockDiscountPct, pct);
                  }
                });

                if (badgeDiscountPct > 0) {
                  discountedBadgePrice = Math.round(badgePriceInt * (1 - badgeDiscountPct / 100));
                }
                if (flockDiscountPct > 0) {
                  discountedFlockPrice = Math.round(flockPriceInt * (1 - flockDiscountPct / 100));
                }
              }
            }
          } catch (e) {
            // fail silently if discount data is not available or malformed
          }
          var totalCents = discountedBadgePrice + discountedFlockPrice + currentVariantPrice;
          priceElem.innerHTML = formatMoney(totalCents, currencyFormat);

          //  update save percentage badge
          let savePercentageBadge = document.querySelector('.save-percentage');
          if (savePercentageBadge) {
            const baseOld = Number(savePercentageBadge.dataset.orginialPrice) || 0;
            const baseNew = Number(savePercentageBadge.dataset.newPrice) || 0;
            const oldTotal = discountedBadgePrice + discountedFlockPrice + baseOld;
            const newTotal = discountedBadgePrice + discountedFlockPrice + baseNew;
            const pct = newTotal != oldTotal ? ((oldTotal - newTotal) / oldTotal) * 100 : 0;
            const badge = savePercentageBadge.querySelector('s');
            if (badge) badge.innerHTML = `-${Math.round(pct)}%`;

            if(document.querySelector('.save-percentage-wrapper .price-item--regular')) document.querySelector('.save-percentage-wrapper .price-item--regular').innerHTML = formatMoney(oldTotal, currencyFormat);
          }

        }
      })
    }
  }

  updateFormInput(triggeredEventTarget) {
    if (triggeredEventTarget.id === 'flock-0') {
      this.removeFormInput(true, false);
    }
    else if (triggeredEventTarget.id === 'badge-0') {
      this.removeFormInput(false, true);
    }
    else {
      let selectedOptionVID = triggeredEventTarget.getAttribute('variant-id');
      let selectedOptionPrice = triggeredEventTarget.getAttribute('variant-price');
      let productFormID = document.querySelector('.product-configurator-block') ? document.querySelector('.product-configurator-block').getAttribute('form-id') : '';
      if (productFormID) {
        if (document.querySelector('form[id="' + productFormID + '"] input[name="' + triggeredEventTarget.name + '"]')) {
          document.querySelector('form[id="' + productFormID + '"] input[name="' + triggeredEventTarget.name + '"]').value = selectedOptionVID;
          document.querySelector('form[id="' + productFormID + '"] input[name="' + triggeredEventTarget.name + '"]').setAttribute('variant-price', selectedOptionPrice);
          document.querySelector('form[id="' + productFormID + '"] input[name="' + triggeredEventTarget.name + '"]').setAttribute('data-title', triggeredEventTarget.value)
          if (triggeredEventTarget.name != 'badge-option') {
            if (triggeredEventTarget.id === 'flock-2') {
              document.querySelector('form[id="' + productFormID + '"] input[name="' + triggeredEventTarget.name + '"]').setAttribute('is-individuell', true);
            } else {
              document.querySelector('form[id="' + productFormID + '"] input[name="' + triggeredEventTarget.name + '"]').setAttribute('is-individuell', false);
            }
          }
        }
        else {
          let inputNode = document.createElement("input");
          inputNode.type = "hidden";
          inputNode.name = triggeredEventTarget.name;
          inputNode.value = selectedOptionVID;
          inputNode.setAttribute('variant-price', selectedOptionPrice);
          inputNode.setAttribute('data-title', triggeredEventTarget.value)

          if (triggeredEventTarget.name != 'badge-option') {
            if (triggeredEventTarget.id === 'flock-2') {
              inputNode.setAttribute('is-individuell', true);
            } else {
              inputNode.setAttribute('is-individuell', false);
            }
          }
          document.querySelector('form[id="' + productFormID + '"]').appendChild(inputNode);
        }
      }
    }
  }

  removeFormInput(isFlock = true, isBadge = true) {
    let productFormID = document.querySelector('.product-configurator-block') ? document.querySelector('.product-configurator-block').getAttribute('form-id') : '';
    isFlock && document.querySelector('form[id="' + productFormID + '"] input[name="flock-option"]') ? document.querySelector('form[id="' + productFormID + '"] input[name="flock-option"]').remove() : '';
    isBadge && document.querySelector('form[id="' + productFormID + '"] input[name="badge-option"]') ? document.querySelector('form[id="' + productFormID + '"] input[name="badge-option"]').remove() : '';
  }

  // Adds badge on overlay
  // addBadgeOnJersey(triggeredEvent) {
  //   if (triggeredEvent.target.id === 'badge-0') {
  //     this.clearJerseyBadges();
  //   } else {
  //     let badgeElem = this.querySelector('.badge-options label[for="' + triggeredEvent.target.id + '"] span');
  //     this.querySelector('.configurator-image .custom-badge-overlay').innerHTML = badgeElem.outerHTML;
  //     this.showJerseyImagePreview();
  //     this.updateBadgeOnProductPreview();
  //   }
  // }

  // Updates the whole jersey image having the badge in it.
  addBadgeOnJersey(triggeredEvent) {
    this.clearJerseyBadges();

    const badgeOption = triggeredEvent.target;
    const jerseyImage = document.querySelector('.configurator-image .jersey-image');

    const imageUrl = badgeOption.getAttribute('data-image-url');
    if (imageUrl && jerseyImage) {
      jerseyImage.src = imageUrl;
      jerseyImage.srcset = '';
    }

    this.showJerseyImagePreview();
    this.updateBadgeOnProductPreview();

  }

  updateJerseyFlock(triggeredEvent) {
    if (triggeredEvent.target.id == 'flock-1') {
      this.changePersonalized(
        this.querySelector('.selected-player-name .player-info') ? this.querySelector('.selected-player-name .player-info').getAttribute('number') : '',
        this.querySelector('.selected-player-name .player-info') ? this.querySelector('.selected-player-name .player-info').getAttribute('name') : ''
      );
    } else if (triggeredEvent.target.id == 'flock-2') {
      this.changePersonalized(
        this.querySelector('.personalize-inputs input#flock-personalize-number') ? this.querySelector('.personalize-inputs input#flock-personalize-number').value : '',
        this.querySelector('.personalize-inputs input#flock-personalize-name') ? this.querySelector('.personalize-inputs input#flock-personalize-name').value : '',
        true
      )
    } else {
      this.clearJerseyPersonalizedData();
    }
  }

  changePersonalized(number = '', name = '', canBeEmpty = false) {
    if (number != '') {
      this.writeNumberOnJersey(number, '', this);
    }
    else if (canBeEmpty) {
      this.clearJerseyPersonalizedData(false, true);
    }
    if (name != '') {
      this.writeNameOnJersey(name, '', this);
    }
    else if (canBeEmpty) {
      this.clearJerseyPersonalizedData(true, false);
    }
    this.updateFormPersonalizedInput(number, name);
  }

  updateFormPersonalizedInput(number = null, name = null) {
    let productFormID = document.querySelector('.product-configurator-block') ? document.querySelector('.product-configurator-block').getAttribute('form-id') : '';
    if (name !== null && document.querySelector('form[id="' + productFormID + '"] input[name="flock-option"]'))
      document.querySelector('form[id="' + productFormID + '"] input[name="flock-option"]').setAttribute('player-name', name);
    if (number !== null && document.querySelector('form[id="' + productFormID + '"] input[name="flock-option"]'))
      document.querySelector('form[id="' + productFormID + '"] input[name="flock-option"]').setAttribute('player-number', number);
  }

  clearJerseyPersonalizedData(nameOnly = false, numberOnly = false) {
    if (!numberOnly)
      this.querySelector('.personalized-flock .name').innerHTML = '';
    if (!nameOnly)
      this.querySelector('.personalized-flock .number').innerHTML = '';

    this.updateFlockOnProductPreview();
  }

  writeNameOnJersey(name = '', triggeredEvent = '') {
    let germanSpecialCharSvg =
      '<span class="specialCharFont"><svg xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="240 170 535 670" style="&#10;    width: auto;&#10;    height: 8.5px;&#10;">\
      <g>\
        <g id="Ebene_1">\
          <path class="cls-1" d="M762.2,673.5v-23.7c0-28.5-6.5-52.2-19.5-71.2-13-19-31.5-36.4-55.6-52.2l-102.6-72.5,64.1-170.4v-114.3h-281c-86.5,11.6-129.7,64.3-129.7,158v6.6l.2,493.4h144.4l-.2-491.8c0-30.4,16.1-45.6,48.4-45.6s35.8,0,57.2,0,12.6,19.8,12.6,19.8l-3.1,8-40.3,102.9s-9,18.6-9,32.9v21.1c0,35.7,26.3,60.8,63.7,86.1,65.2,43.1,90.6,68.4,98.2,76,6.3,5.7,9.5,13.3,9.5,22.8v8.5c0,12-5.9,21.1-17.6,27.1-11.7,6-35.6,9-71.7,9s-69-4.4-98.8-13.3v128.2c34.2,8.2,75.3,12.3,123.5,12.3,138,0,207-52.5,207-157.7h0Z"/>\
        </g>\
      </g>\
    </svg></span>';
    if (name != '') {
      this.querySelector('.personalized-flock .name').innerHTML = name.replace('ß', germanSpecialCharSvg);
      this.updateFormPersonalizedInput(null, name);
    } else {
      let validName = this.validateNameInput(triggeredEvent);
      this.querySelector('.personalized-flock .name').innerHTML = validName.replace('ß', germanSpecialCharSvg);
      this.updateFormPersonalizedInput(null, validName);
    }
    this.showJerseyImagePreview();
    this.updateFlockOnProductPreview();
  }

  writeNumberOnJersey(number = '', triggeredEvent = '', temp_this) {
    const flockNumbersJson = document.querySelector('[jersey-json-data]');
    const flockNumbersArr = JSON.parse(flockNumbersJson.innerHTML);
    let digits = [];
    let numbersContainer = temp_this.querySelector('.personalized-flock .number');
    let imgNum = '';
    let isValidNumber = true;
    let customNumber = number !== '' ? number : triggeredEvent.target.value;
    numbersContainer.innerHTML = '';
    digits = number !== '' ? ("" + number).split("") : ("" + triggeredEvent.target.value).split("");
    if (digits.length > 1 && number === '') {
      isValidNumber = temp_this.validateNumberInput(triggeredEvent);
    }
    if (isValidNumber) {
      digits.forEach(function (digit) {
        imgNum = flockNumbersArr.flocking['number_' + digit];
        if (imgNum != '') {
          let newDiv = document.createElement("div");
          newDiv.innerHTML = imgNum ? imgNum.image : digit;
          numbersContainer.appendChild(newDiv);
        }
      })
      this.updateFormPersonalizedInput(customNumber, null);
    }
    else {
      this.updateFormPersonalizedInput('', '');
    }
    this.showJerseyImagePreview();
    this.updateFlockOnProductPreview();
  }

  showJerseyImagePreview() {
    if (document.querySelector('.image-configurator-thumbnail'))
      document.querySelector('.image-configurator-thumbnail').classList.remove('hidden');
    if (document.querySelector('.image-configurator-thumbnail button'))
      document.querySelector('.image-configurator-thumbnail button').click();
    if (document.querySelector('.configurator-image-preview'))
      document.querySelector('.configurator-image-preview').classList.remove('hidden');
  }

  updateFlockOnProductPreview() {
    //add selected flock to preview image
    if (document.querySelector('.product__media-list .product__media .personalized-flock'))
      document.querySelector('.product__media-list .product__media .personalized-flock').innerHTML = this.querySelector('.configurator-image .personalized-flock').innerHTML;
  }

  updateBadgeOnProductPreview() {
    // Add selected badge to preview image overlay
    // if (document.querySelector('.product__media-list .product__media .custom-badge-overlay'))
    //   document.querySelector('.product__media-list .product__media .custom-badge-overlay').innerHTML = this.querySelector('.configurator-image .custom-badge-overlay').innerHTML;

    // Update preview image with the selected badge
    const configuratorJerseyImage = document.querySelector('.configurator-image .jersey-image');
    const previewJerseyImage = document.querySelector('.product__media-list .product__media .jersey-image');

    const imageUrl = configuratorJerseyImage.src;
    if (imageUrl && previewJerseyImage) {
      previewJerseyImage.src = imageUrl;
      previewJerseyImage.srcset = '';
    }
  }

  setHeaderCartIconAccessibility() {
    const drawerLink = document.querySelector('#configurator-customize-button');
    drawerLink.setAttribute('role', 'button');
    drawerLink.setAttribute('aria-haspopup', 'dialog');
    drawerLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(drawerLink);
    });
    drawerLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(drawerLink);
      }
    });
  }

  validateNameInput(triggeredEvent) {
    let inputValue = triggeredEvent.target.value;
    const playerNamesBlacklistJson = document.querySelector('[jersey-json-data]');
    if (playerNamesBlacklistJson) {
      const blacklistWordsArr = JSON.parse(playerNamesBlacklistJson.innerHTML).playerNameBlacklist.split('|');
      if (blacklistWordsArr.length > 0) {
        blacklistWordsArr.forEach(function (word) {
          let wordLower = word.toLowerCase();
          let inputValueLower = inputValue.toLowerCase();
          if (inputValueLower.match(wordLower)) {
            let wordIndex = inputValueLower.indexOf(wordLower);
            let wordLength = wordLower.length;
            //to remove all blacklist in any letters combinations (Upper or lower)
            triggeredEvent.target.value = inputValue.substring(0, wordIndex) + inputValue.substring(wordIndex + wordLength, inputValue.length);
            // triggeredEvent.target.value = triggeredEvent.target.value.replace(word, '');
            return triggeredEvent.target.value;
          }
        })
      }
    }
    return triggeredEvent.target.value;
  }

  validateNumberInput(triggeredEvent) {
    let inputValue = triggeredEvent.target.value;
    const playerNumBlacklistJson = document.querySelector('[jersey-json-data]');
    const blacklistNumbersArr = JSON.parse(playerNumBlacklistJson.innerHTML).playerNumBlacklist.split('|');

    if (blacklistNumbersArr.includes(inputValue)) {
      triggeredEvent.target.value = '';
      return false;
    }
    return true;
  }

  configuratorAction(triggeredBy) {
    if (triggeredBy.target.id === 'reset-configurator') {
      this.resetConfigurator();
      this.clearJerseyPersonalizedData();
      this.clearJerseyBadges();
      this.removeFormInput();
      this.updatePrice();
      this.updateInputMaxLenText(null);
    } else if (triggeredBy.target.id === 'save-configurator') {
      let isRequiredFieldFilled = this.isCustomNumberFilled();
      let isPlayerSelected = this.isPlayerSelected();
      isRequiredFieldFilled && isPlayerSelected ? this.close(true) : '';
    }
  }

  clearJerseyBadges() {
    this.querySelector('.custom-badge-overlay') ? this.querySelector('.custom-badge-overlay').innerHTML = '' : '';
    document.querySelector('.product__media-list .product__media .custom-badge-overlay') ? document.querySelector('.product__media-list .product__media .custom-badge-overlay').innerHTML = '' : '';
  }

  isCustomNumberFilled() {
    //make custom number input required before saving
    let selectedFlockOption = this.querySelector('.flock-options input[name="flock-option"]:checked');
    if (selectedFlockOption && selectedFlockOption.id === 'flock-2') {
      if (this.querySelector('#flock-personalize-number').value === '') {
        this.querySelector('.personalized-number-alert').classList.remove('hidden');
        setTimeout(() => {
          this.querySelector('.personalized-number-alert').classList.add('hidden');
        }, 5000);
        return false;
      }
      else {
        this.querySelector('.personalized-number-alert').classList.add('hidden');
        return true;
      }
    }
    return true;
  }

  isPlayerSelected() {
    //Check if second flock is selected with players dropdown, make sure at least one player is selected before saving
    let selectedFlockOption = this.querySelector('.flock-options input[name="flock-option"]:checked');
    if (selectedFlockOption) {
      if (selectedFlockOption.id === 'flock-1') {
        if (this.querySelector('.selected-player-name .player-info')) {
          return true;
        }
        else {
          this.querySelector('.select-player-alert').classList.remove('hidden');
          setTimeout(() => {
            this.querySelector('.select-player-alert').classList.add('hidden');
          }, 5000);
          return false
        }
      }
    }
    return true;
  }

  resetConfigurator() {
    //reset flock
    let flockDefaultOption = this.querySelectorAll('input[name="flock-option"]');
    flockDefaultOption.length > 0 ? flockDefaultOption[0].checked = true : null;
    this.resetPlayersDropdown();

    //hide any open flock options
    this.HideAllFlockOptions();

    //reset personalized inputs
    let flockPersonalizeEle = this.querySelectorAll('input[name="flock-personalize"]');
    flockPersonalizeEle.forEach(function (option) { option.value = ''; })
    this.querySelector('.required-field') && this.querySelector('.required-field').classList.add('hidden');

    //reset badges
    let badgeDefaultOption = this.querySelectorAll('input[name="badge-option"]');
    badgeDefaultOption.length > 0 ? badgeDefaultOption[0].checked = true : null;

    //reset jersey preview image
    document.querySelector('.product__media-list .product__media .personalized-flock').innerHTML = '';
    document.querySelector('.image-configurator-thumbnail') && document.querySelector('.image-configurator-thumbnail').classList.add('hidden');
    document.querySelector('.configurator-image-preview') && document.querySelector('.configurator-image-preview').classList.add('hidden');
    // let ImageDefaultSelect = document.querySelectorAll('.thumbnail-list li');
    let ImageDefaultSelect = document.querySelectorAll('.thumbnail-list__item:not(.image-configurator-thumbnail)');
    if (ImageDefaultSelect.length > 1) {
      ImageDefaultSelect[0].querySelector('button').click();
    }
  }

  resetPlayersDropdown() {
    const selectedPlayerNameLabelJson = document.querySelector('[jersey-json-data]');
    const selectedPlayerNameLabel = JSON.parse(selectedPlayerNameLabelJson.innerHTML).selectedPlayerNameLabel;
    if (this.querySelector('.selected-player-name'))
      this.querySelector('.selected-player-name').innerHTML = selectedPlayerNameLabel;
  }

  pickPlayer(triggeredBy) {
    if (triggeredBy.srcElement.hasAttribute('number')) {
      if (triggeredBy.srcElement.getAttribute('number') != '')
        this.writeNumberOnJersey(triggeredBy.srcElement.getAttribute('number'), '', this);
    }
    if (triggeredBy.srcElement.hasAttribute('name')) {
      if (triggeredBy.srcElement.getAttribute('name') != '')
        this.writeNameOnJersey(triggeredBy.srcElement.getAttribute('name'));
    }
    this.querySelector('.selected-player-name').innerHTML = triggeredBy.srcElement.outerHTML;
    this.togglePlayersDropdown();
  }

  togglePlayersDropdown(event, isHide = false) {
    if (isHide) {
      this.querySelector('.flock-players-options .players-container') && this.querySelector('.flock-players-options .players-container').classList.add('hidden');
      this.querySelector('.flock-players-options') && this.querySelector('.flock-players-options').classList.remove('opened');
    } else {
      this.querySelector('.flock-players-options .players-container') && this.querySelector('.flock-players-options .players-container').classList.toggle('hidden');
      this.querySelector('.flock-players-options') && this.querySelector('.flock-players-options').classList.toggle('opened');
    }
  }

  toggleFlockHandler(triggeredBy) {
    this.HideAllFlockOptions();
    this.querySelector('#' + triggeredBy.target.id + '-option') && this.querySelector('#' + triggeredBy.target.id + '-option').classList.remove('hidden');
  }

  HideAllFlockOptions() {
    this.querySelectorAll('.flock-option-block').forEach(function (flock_option) {
      flock_option.classList.add('hidden');
    })
  }

  showSelectedOptions() {
    this.querySelector('.flock-options input[name="flock-option"]:checked') && this.querySelector('.flock-options input[name="flock-option"]:checked').click();
    this.querySelector('.badge-options input[name="badge-option"]:checked') && this.querySelector('.badge-options input[name="badge-option"]:checked').click();
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role'))
      this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('configuratorDrawer');
        const focusElement =
          this.querySelector('.drawer__inner') ||
          this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
    this.showSelectedOptions();
  }

  close(isSaving = false) {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
    if (!isSaving || typeof isSaving === 'object') {
      this.resetConfigurator();
      this.clearJerseyPersonalizedData();
      this.clearJerseyBadges();
      this.resetConfigurator();
      this.removeFormInput();
      this.updateInputMaxLenText(null);
    }
    this.updatePrice();
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute(
        'aria-controls',
        cartDrawerNote.nextElementSibling.id
      );
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute(
        'aria-expanded',
        !event.currentTarget.closest('details').hasAttribute('open')
      );
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      sectionElement.innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      );
    });

    setTimeout(() => {
      this.querySelector('#configuratorDrawer-Overlay').addEventListener(
        'click',
        this.close.bind(this)
      );
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'configurator-drawer',
        selector: '#configuratorDrawer',
      }
    ];
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('configurator-drawer', configuratorDrawer);
